import React, {useState} from 'react'
import {gql, useMutation,useQuery} from "@apollo/client";
import '../App.css'


const CREAR_PRODUCTO = gql `
mutation crearProducto($nombre: String, $imagen:String, $precio:Int, $codigo: String, $stock: Int){
    crearProducto(nombre: $nombre, imagen:$imagen, precio: $precio, codigo:$codigo, stock:$stock){
   _id
    nombre
    precio
    stock
    codigo
    imagen
    }
}`



const GET_PRODUCTO =gql`
query getProductos{
  getProductos{
    _id
    nombre
    imagen
    precio
    codigo
    stock
  }
}`

const ELIMINAR_PRODUCTO = gql `mutation eliminarProducto($id:ID!){
  eliminarProducto(_id:$id)
  }`;

  const ACTUALIZAR_PRODUCTO = gql `
  mutation editarProducto($id:ID!, $nuevoNombre:String, $nuevaImagen:String,$nuevoCodigo:String, $nuevoStock:Int, $nuevoPrecio:Int){
      editarProducto(_id: $id, nombre:$nuevoNombre, imagen:$nuevaImagen, codigo:$nuevoCodigo, stock: $nuevoStock, precio: $nuevoPrecio){
     _id
      nombre
      precio
      stock
      codigo
      imagen
      }
  }`

function CrearProducto() {
  const {loading, error, data} = useQuery(GET_PRODUCTO);
   
  const [editingProduct, setEditingProduct] = useState(null);
  const [nuevoNombre, setNuevoNombre] = useState('')
  const [nuevaImagen, setNuevaImagen] = useState('')
  const [nuevoCodigo, setNuevoCodigo] = useState('')
  const [nuevoStock, setNuevoStock] = useState(0);
  const [nuevoPrecio, setNuevoPrecio] = useState(0)
 const [editarProducto] = useMutation(ACTUALIZAR_PRODUCTO)
  
    const [nombre, setNombre]=useState('');
    const [precio, setPrecio]=useState(0);
    const [stock, setStock]=useState(0);
    const [codigo, setCodigo]=useState('');
    const [imagen, setImagen]= useState('');
    const [crearProducto] = useMutation(CREAR_PRODUCTO, {
      refetchQueries: [{ query: GET_PRODUCTO }],  
    });
     const productoSubmit = e =>{
        crearProducto({variables:{nombre, precio, stock, codigo, imagen}});
        setNombre('');
        setPrecio(0);
        setStock(0);
        setCodigo('');
        setImagen('');

         
    
     }
     
     const [eliminarProducto] = useMutation(ELIMINAR_PRODUCTO, {
      refetchQueries: [{ query: GET_PRODUCTO}]
    });
   
     if(loading) return <p>Esperando resultados...</p>;
     if(error) return <p>Error</p>;
     const ordenAlbabetico = data.getProductos
  .slice()
  .sort((a, b) => a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' }));

      
 return (
  <div>
    <div class="card card-salida" >
    <div class="card-body">
      <h2 class="card-title">Agregar producto</h2>
      <form onSubmit={productoSubmit}>
        <h6>Producto</h6>
    <input  placeholder='nombre' value={nombre} onChange={evt=>setNombre(evt.target.value)}></input>
    <h6>Precio</h6>
    <input placeholder='precio' value={precio} onChange={evt=>setPrecio(parseInt(evt.target.value))}></input>
    <h6>Codigo de barras</h6>
    <input placeholder='codigo' value={codigo} onChange={evt=>setCodigo(evt.target.value)}></input>
    <h6>Stock</h6>
    <input placeholder='stock' value={stock} onChange={evt=>setStock(parseInt(evt.target.value))}></input>
    <h6>Url de la imagen</h6>
    <input placeholder='imagen' value={imagen} onChange={evt=>setImagen(evt.target.value)}></input>
     
      <button className="btn btn-salida">Agregar producto</button>
        
        </form>
</div>
</div>
<div class="container">
  <div className="row">  
        {ordenAlbabetico.map((producto)=>
        <><div className="card card-entrada col-xs-12 col-xl-4 col-sm-6" >
        <div className="card-body">
          <h1>{producto.nombre}</h1>
          
<img src={producto.imagen} alt="" width="100px" />
<h3>$ {producto.precio}</h3>&nbsp; <h1>{producto.stock}<h4>Disponible(s)</h4></h1>
<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVcAAACTCAMAAAAN4ao8AAAAYFBMVEUAAAD///+RkZHp6ekhISHc3Nzi4uJ3d3fCwsKkpKQeHh7y8vI4ODivr6/8/PyNjY1fX199fX2dnZ0YGBhLS0tycnILCwtZWVm1tbXR0dFSUlJsbGxAQEAsLCzX19cSEhJh+ML6AAABtklEQVR4nO3b204CMRAA0Cm35X4TBQTk///Sdl1lTXgzMS6eeYChKTPTE9KQECI+YtjPD8dZ82o5jJhMS7beNEuDlNK4zkZ563YQtziPUpX3p/40qnTKyTW/L91i3eybHSNOzVrp1EvzeEqHnF3K0u5raVG6NBtXEYfUFLi0ivbKmOOYp23EW5lsl0bPraFeJvlQyzpdNMVL7Ff1U246/qz6/ej7Vo9N6VDOUkVrol681t0XedZy7LsRd4v/tmspns5cuXL9gWvFlStXrly5cuXKlStXrly5cuXKlStXrly5cuXKlStXrly5cuXKlStXrly5cuXaddcLV65dc/17/y94DFefV64dca2/D7gHuHLlypUrV65cuXLlypUrV65cuXL9165+L+DKlav7lWuXXN0DXLly5cqVK1euXLly5cqVK1euXLly5cqVK1euXLly5cqVK1euXLly5cqVK1euXLly5cqVK1euXLly5cqVK1euXLly5cqVK1euXLly5cqVK1euXLly5cqVK1euXLly5cqVK1euXLly5cqVK1euXLly5cqVK1euXLly5cqVK1euXLlyfTzXd/z0s1HkpkUwAAAAAElFTkSuQmCC" alt="" width="80px"/>
<p>{producto.codigo}</p>
          <button className="btn btn-danger" onClick={()=>{
            eliminarProducto({ variables:{id:producto._id} });
          }}  disabled={loading}>
          eliminar
           </button>

           {editingProduct === producto._id ? (
  <>
  <p>Producto</p>
   <input
  type="text"
  value={nuevoNombre}
  onChange={(e) => setNuevoNombre(e.target.value)}
/>
<p>codigo</p>
   <input
  type="text"
  value={nuevoCodigo}
  onChange={(e) => setNuevoCodigo(e.target.value)}
/>
<p>Imagen(url)</p>
   <input
  type="text"
  value={nuevaImagen}
  onChange={(e) => setNuevaImagen(e.target.value)}
/>
  <p>unidades disponibles</p>
  <input
  type="number"
  value={nuevoStock}
  onChange={(e) => setNuevoStock(parseInt(e.target.value))}
/>
<p>Precio</p>
<input
  type="number"
  value={nuevoPrecio}
  onChange={(e) => setNuevoPrecio(parseInt(e.target.value))}
/>
<button
className="btn btn-primary"
onClick={() => {
  editarProducto({
    variables: { id: producto._id,nuevoNombre, nuevaImagen, nuevoCodigo, nuevoStock, nuevoPrecio, nuevoNombre },
  });
  setEditingProduct(null);
  setNuevoNombre('')
  setNuevoNombre('');
  setNuevoCodigo('');
  setNuevoStock(0);
  setNuevoPrecio(0);
  
}}
>
Guardar
</button>
</>
): (
  <>
    
    <button
      className="btn btn-primary"
      onClick={() => {
        setEditingProduct(producto._id);
        setNuevoNombre(producto.nombre);
        setNuevoCodigo(producto.codigo);
        setNuevaImagen(producto.imagen);
        setNuevoStock(producto.stock);
        setNuevoPrecio(producto.precio);
      }}


    >
      Editar
    </button>
  </>
)}
 </div>
  
  </div>
           </>
        )
        }
        </div>
    </div>
  </div>
  )
}

export default CrearProducto;